import { toast } from "react-toastify";

export default function toastFile(
  type: "success" | "warning" | "error",
  message: string
): void {
  if (type === "success") {
    toast.success(message);
  } else if (type === "warning") {
    toast.warning(message);
  } else if (type === "error") {
    toast.error(message);
  }
}
